module.exports = {
  resources: [
    {
      title: "Austin History Center",
      url: "https://library.austintexas.gov/ahc/about-us"
    },
    {
      title: "Dolph Briscoe Center for American History",
      url: "https://www.cah.utexas.edu/index.php"
    },
    {
      title:
        "Forever Free: Nineteenth Century African American Legislators and Constitutional Convention Delegates of Texas",
      url: "https://www.tsl.texas.gov/exhibits/forever/index.html"
    },
    {
      title: "Handbook of African American Texas",
      url: "https://tshaonline.org/handbook/african-americans"
    },
    {
      title: "Handbook of Texas",
      url: "https://tshaonline.org/handbook"
    },
    {
      title: "Handbook of Texas Women",
      url: "https://tshaonline.org/handbook"
    },
    {
      title: "Humanities Texas Online Resources",
      url: "https://www.humanitiestexas.org/education/online-resources"
    },
    {
      title: "Teaching Hard History: American Slavery",
      url:
        "https://www.tolerance.org/frameworks/teaching-hard-history/american-slavery"
    },
    {
      title: "The African American Story: Bob Bullock Museum",
      url:
        "https://www.thestoryoftexas.com/discover/campfire-stories/african-americans"
    },
    {
      title: "The Project Gutenberg: Texas Slave Narratives",
      url: "http://www.gutenberg.org/files/30576/30576-h/30576-h.htm"
    },
    {
      title: "Texas Domestic Slave Trade Project",
      url: "https://txdst.la.utexas.edu"
    },
    {
      title: "Texas Freedom Colonies",
      url: "https://spark.adobe.com/page/zOAH5v4Wcfzxx/"
    },
    {
      title: "Texas Runaway Slave Project",
      url: "https://digital.sfasu.edu/digital/collection/RSP/search"
    },
    {
      title: "Texas Slavery Project",
      url: "http: //www.texasslaveryproject.org"
    },
    {
      title: "Texas State Library and Archives Commission",
      url: "https://www.tsl.texas.gov"
    },
    {
      title: "Voices Remembering Slavery: The Library of Congress",
      url:
        "https://www.loc.gov/collections/voices-remembering-slavery/about-this-collection"
    },
    {
      title: 'Writing about "Slavery"? This Might Help',
      url:
        "https://docs.google.com/document/d/1A4TEdDgYslX-hlKezLodMIM71My3KTN0zxRv0IQTOQs/mobilebasic"
    },
    {
      title: "The Portal to Texas History",
      url: "https://texashistory.unt.edu"
    },
    {
      title: "Documenting the American South",
      url: "https://docsouth.unc.edu"
    },
    {
      title: "Race and Slavery Petitions Project",
      url: "https://library.uncg.edu/slavery/petitions/"
    },
    {
      title: "Slavery Images",
      url: "http://www.slaveryimages.org/s/slaveryimages/page/welcome"
    },
    {
      title:
        "Library of Congress Slave Narratives from the Federal Writers’ Project, 1936-1938",
      url:
        "https://www.loc.gov/collections/slave-narratives-from-the-federal-writers-project-1936-to-1938/about-this-collection/"
    },
    {
      title: "Slave Voyages",
      url: "https://www.slavevoyages.org"
    }
  ]
};
